import { ref } from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
import { define, welcNotifyDuration } from '@/data/globals.js'
import useNotify from '@/hooks/useNotify'
import notifys from '@/data/languages/notifications/useAuthData'
import useLang from '@/hooks/useLang'

export default function useAuth () {
  const store = useStore()
  const { pushNotify } = useNotify()
  const { lang } = useLang()
  const email = ref('user@gmail.com')
  const password = ref('888')
  const isAuthLoading = ref(false)


  let gettedItem = localStorage.getItem('AccessToken')
  if(gettedItem) gettedItem = encodeURI(gettedItem)
  const localToken = ref(gettedItem)
  // Для информации:
  // encodeURI заменяет киррилические и другие символы на соответствующими им UTF-8 escape-последовательности. Незаменяемые символы: латинский алфавит, десятичные цифры, - _ . ! ~ * ' ( ) #
  // console.log('localToken.value.length: ', localToken.value.length);

  async function login() {
    isAuthLoading.value = true
    try {
      const response = await axios.post( define.pathToAPI + "/access/login.php", 
        JSON.stringify({
          email: email.value,
          password: password.value,
        }),
        {
          withCredentials: true, // определяет, должны ли создаваться кросс-доменные Access-Control запросы с использованием таких идентификационных данных как cookie, авторизационные заголовки или TLS сертификаты. Если здесь установили true, то на стороне бека нужно установить header("Access-Control-Allow-Credentials: true")
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      ) // axios


      if(response.data.status === 'approved' &&
        response.data.accessToken &&
        response.data.name
      ){
        localStorage.setItem('AccessToken', response.data.accessToken)
        localStorage.setItem('name', response.data.name)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.accessToken

        // Добро пожаловать!<br>Вам открыт доступ к приложению
        pushNotify( notifys[lang.value].welcome, "notifyWelcome", welcNotifyDuration)
        notifys[lang.value]

        store.commit('SetIsAuth', true)

      } else {
        // Ошибка. Сервер вернул некорректный ответ
        pushNotify( notifys[lang.value].incorrectResp, 'notifyOrange')
      }

    } catch (e) {

      if(e.code === 'ERR_NETWORK') {
        // Нет подключения к серверу
        pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
        // console.log('Нет подключения к серверу')
        return
      }

      // Обработка ошибок, когда front и back на разных хостах (CORS):
      switch(e.response.data.status) {
        case 'expired':
          tokenRefresh()
          break
        case 'denied':
          // Доступ закрыт<br>Проверьте логин и пароль
          pushNotify( notifys[lang.value].text1, 'notifyOrange')
          break
        default:
          // Ошибка. Подробности в консоли
          pushNotify( notifys[lang.value].someError, 'notifyOrange')
          console.log(e)
          break
      } // switch

    } finally {
      isAuthLoading.value = false
    } // try
  
  } // login

  async function logout() {
    isAuthLoading.value = true
    try {
      const response = await axios.post( define.pathToAPI + "/access/logout.php", 
        JSON.stringify({
          message: 'Привет сервер! С этим сообщением ты сможешь прочитать cookie', // отправляем любые данные (любое поле), если хотим читать cookie на беке при CORS
          // Важно! Для информации:
          // Cookie передаются в заголоке POST запроса.
          // Однако, при CORS, делаются не 1 а 2 запроса (OPTIONS и за ним POST).
          // Причем, если в axios мы не добавим хотя бы одно поле данных (отправим только заголовки), то в таком случае будет отправлен только 1 запрос OPTIONS. А, значит, на беке мы не сможем прочитать cookie. Их нет в OPTIONS, а второй запрос (POST) с cookie, не будет передан!
        }),
        {
          withCredentials: true, // определяет, должны ли создаваться кросс-доменные Access-Control запросы с использованием таких идентификационных данных как cookie, авторизационные заголовки или TLS сертификаты. Если здесь установили true, то на стороне бека нужно установить header("Access-Control-Allow-Credentials: true");
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      ) // axios


      if(response.data.status === 'ok'){
        removeAccessData()
        // Вы вышли из приложения
        pushNotify( notifys[lang.value].bye, "notifyWelcome", welcNotifyDuration)
      } else {
        // Ошибка. Ответ сервера: ...<br>Подробности в консоли
        pushNotify( notifys[lang.value].text5_1 + response.data.error + notifys[lang.value].text5_2, 'notifyOrange')
        // console.log(response)
      }

    } catch (e) {
      
      if(e.code === 'ERR_NETWORK') {
        // Нет подключения к серверу
        pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
        // console.log('Нет подключения к серверу')
        return
      }

    } finally {
      isAuthLoading.value = false
    } // try
  } // logout




  function removeAccessData() {
    delete axios.defaults.headers.common['Authorization']
    store.commit('SetIsAuth', false)
    localStorage.removeItem('AccessToken')
    localStorage.removeItem('name')
  } // removeAccessData




  async function validateToken() {
    
    // Если в localStorage не найдет токен - прерываем функцию
    if(!localToken.value) {
      // Меняем статус appIsStarting, когда стало ясно, залогинен ли пользователь
      if(store.state.appIsStarting) store.commit('SetAppIsStarting', false)
      return
    }
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localToken.value

    isAuthLoading.value = true
    try {
      const response = await axios.post( define.pathToAPI + "/access/validate_token.php", 
        // JSON.stringify({
        //   // test: 'Test_Value',
        //   message: 'Привет сервер! С этим сообщением ты сможешь прочитать cookie', // отправляем любые данные (любое поле), если хотим читать cookie на беке при CORS
        //   // Важно! Для информации:
        //   // Cookie передаются в заголоке POST запроса.
        //   // Однако, при CORS, делаются не 1 а 2 запроса (OPTIONS и за ним POST).
        //   // Причем, если в axios мы не добавим хотя бы одно поле данных (отправим только заголовки), то в таком случае будет отправлен только 1 запрос OPTIONS. А, значит, на беке мы не сможем прочитать cookie. Их нет в OPTIONS, а второй запрос (POST) с cookie, не будет передан!
        // }),
        {
          withCredentials: true, // определяет, должны ли создаваться кросс-доменные Access-Control запросы с использованием таких идентификационных данных как cookie, авторизационные заголовки или TLS сертификаты. Если здесь установили true, то на стороне бека нужно установить header("Access-Control-Allow-Credentials: true");
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      ) // axios

      if(response.data.status === 'allowed'){
        // У вас есть доступ к приложению
        pushNotify( notifys[lang.value].hiAgain, "notifyWelcome", welcNotifyDuration)
        store.commit('SetIsAuth', true)

      } else {
        // Ошибка. Ответ сервера: ...<br>Подробности в консоли
        pushNotify( notifys[lang.value].text5_1 + response.data.error + notifys[lang.value].text5_2, 'notifyOrange')
        // console.log(response)
      }

    } catch (e) {

      if(e.code === 'ERR_NETWORK') {
        // Нет подключения к серверу
        pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
        // console.log('Нет подключения к серверу')
        return
      }

      // Обработка ошибок, когда front и back на разных хостах (CORS):
      switch(e.response.data.status) {
        case 'expired':
          tokenRefresh()
          break
        case 'failed':
          // Alarm! Передан некорректный токен.<br>Доступ закрыт
          pushNotify( notifys[lang.value].incorrectToken, 'notifyRed')
          break
        case 'denied':
          // Alarm! Передан пустой токен.<br>Доступ закрыт
          pushNotify( notifys[lang.value].emptyToken, 'notifyRed')
          break
        default:
          // Ошибка. Подробности в консоли
          pushNotify( notifys[lang.value].someError, 'notifyOrange')
          console.log(e)
          break
      } // switch

    } finally {
      isAuthLoading.value = false
      // Меняем статус appIsStarting, когда стало ясно, залогинен ли пользователь
      if(store.state.appIsStarting) store.commit('SetAppIsStarting', false)
    }  // try
  } // validateToken




  async function tokenRefresh() {
    isAuthLoading.value = true
    try {
      const response = await axios.post( define.pathToAPI + "/access/refresh_token.php", 
        JSON.stringify({
          message: 'Привет сервер! С этим сообщением ты сможешь прочитать cookie', // отправляем любые данные (любое поле), если хотим читать cookie на беке при CORS
          // Важно! Для информации:
          // Cookie передаются в заголоке POST запроса.
          // Однако, при CORS, делаются не 1 а 2 запроса (OPTIONS и за ним POST).
          // Причем, если в axios мы не добавим хотя бы одно поле данных (отправим только заголовки), то в таком случае будет отправлен только 1 запрос OPTIONS. А, значит, на беке мы не сможем прочитать cookie. Их нет в OPTIONS, а второй запрос (POST) с cookie, не будет передан!
        }),
        {
          withCredentials: true, // определяет, должны ли создаваться кросс-доменные Access-Control запросы с использованием таких идентификационных данных как cookie, авторизационные заголовки или TLS сертификаты. Если здесь установили true, то на стороне бека нужно установить header("Access-Control-Allow-Credentials: true");
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          }
        }
      ) // axios

      if(response.data.status === 'approved' &&
        response.data.accessToken
      ){
        // Access Token обновлен<br>У вас есть доступ к приложению
        pushNotify( notifys[lang.value].accTokenUpdated, "notifyWelcome", welcNotifyDuration)
        store.commit('SetIsAuth', true)
        localStorage.setItem('AccessToken', response.data.accessToken)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.accessToken
        return true
      } else {
        // Ошибка. Ответ сервера: ...<br>Подробности в консоли
        pushNotify( notifys[lang.value].text5_1 + response.data.error + notifys[lang.value].text5_2, 'notifyOrange')
        // console.log(response)
        return
      }

    } catch (e) {
      
      if(e.code === 'ERR_NETWORK') {
        // Нет подключения к серверу
        pushNotify( notifys[lang.value].errNetwork, 'notifyOrange')
        // console.log('Нет подключения к серверу')
        return
      }

      // Обработка ошибок, когда front и back на разных хостах (CORS):
      switch(e.response.data.status) {
        case 'expired':
          // Залогиньтесь
          pushNotify( notifys[lang.value].loginPlease, 'notifyBlue')
          removeAccessData()
          return // break
        case 'failed':
          // Alarm! Передан некорректный токен.<br>Доступ закрыт
          pushNotify( notifys[lang.value].incorrectToken, 'notifyRed')
          return // break
        case 'denied':
          // Залогиньтесь
          pushNotify( notifys[lang.value].loginPlease, 'notifyBlue')
          removeAccessData()
          return // break
        case 'locked':
          // Ошибка безопастности<br>Похоже на подделку токена доступа<br>Залогиньтесь или обратитесь в поддержку
          pushNotify( notifys[lang.value].fakeToken, 'notifyBlue', welcNotifyDuration)
                                    // console.log('Service is locked')
          removeAccessData()
          return // break
        default:
          // Ошибка. Подробности в консоли
          pushNotify( notifys[lang.value].someError, 'notifyOrange')
          console.log(e)
          return // break
      } // switch

    } finally {
      isAuthLoading.value = false
    } // try
  
  } // tokenRefresh



  return { email, password, login, logout, validateToken, tokenRefresh, isAuthLoading }
}